// state
export const state = {
  addosErrors: 0,
  selectedTab: 0,
};

// mutations
export const mutations = {
  SET_ADDONS_ERRORS_INIT: (state) => {
    state.addosErrors = 0;
  },
  SET_ADDONS_ERRORS: (state, data) => {
    state.addosErrors = data;
  },
  SET_SELECTED_TAB: (state, data) => {
    state.selectedTab = data;
  },
};

// actions
export const actions = {
  set_AddosErrorsInit({ commit }) {
    commit("SET_ADDONS_ERRORS_INIT");
  },
  set_AddosError({ commit }, payload) {
    commit("SET_ADDONS_ERRORS", payload);
  },
  setSelectedTab({ commit }, payload) {
    commit("SET_SELECTED_TAB", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
